import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the SelectBankTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-bank-type',
  templateUrl: 'select-bank-type.html',
})
export class SelectBankTypePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectBankTypePage');
  }

  gotoPage(page, options = {}){
    this.navCtrl.push(page, options);
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-bank-type/select-bank-type.ts